<template>
  <div />
</template>

<script>
export default {
  name: "CrlyEntry"
};
</script>

<style lang="scss" scoped></style>
